<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu
      activeNav="Orders"
      childName="Create Guest"
    ></side-menu>

    <div class="content">
      <div class="dashboard">
        <heading v-if="event" title="Add Guest"></heading>

        <div class="btns">
          <v-select
            :options="order_types"
            :searchable="false"
            :clearable="false"
            placeholder="Order Type"
            v-model="order_type"
          ></v-select>
        </div>
        <div class="tix_error" v-if="!tickets.length">
          <p style="color: red">No tickets has been added.</p>
        </div>
      </div>
      <table class="add-attendees-table">
        <thead>
          <td>Ticket Type</td>
          <td>Amount Sold</td>
          <td>Amount Available</td>
          <td>Price</td>
          <td>Quantity</td>
          <td>Face Value</td>
        </thead>

        <tr v-for="ticket in tickets" :key="ticket.id">
          <td id="name" data-label="Ticket Type">
            {{ ticket.name }}
          </td>
          <td id="sold" data-label="Sold">{{ ticket.amount_sold }} Tix</td>
          <td id="sold" data-label="Sold">
            {{ ticket.amount_available }}/{{ ticket.quantity }}
          </td>
          <td id="price" data-label="Price">
            {{ priceFilter(ticket) }}
          </td>
          <td id="quantity" data-label="Quantity">
            <input
              v-model="selectedTickets[ticket.ticket_id]"
              @change="calculateFaceValue(ticket)"
              type="number"
              min="0"
            />
          </td>
          <td
            v-if="ticket.type != 'donate'"
            class="face-value"
            data-label="Face Value"
          >
            <input
              @change="calculateTotal()"
              v-model="face_values[ticket.ticket_id]"
              type="number"
              min="0"
            />
          </td>
          <td v-else id="quantity" data-label="Quantity" class="face-value">
            <input
              @change="calculateTotal()"
              v-model="face_values[ticket.ticket_id]"
              type="number"
              min="1"
            />
          </td>
        </tr>
      </table>

      <div
        v-if="showTicketOrder"
        :style="{
          display: 'flex',
          width: '100%',
          justifyContent: 'flex-end',
        }"
      >
        <div :style="{ display: 'flex', alignItems: 'center' }">
          <h5
            :style="{
              marginRight: '20px',
              fontSize: '15px',
              fontWeight: '600',
            }"
          >
            Total Value
          </h5>
          <div>
            <span class="input-symbol-dollar">
              <input
                v-model="total"
                style="cursor: not-allowed"
                type="text"
                readonly
              />
            </span>
          </div>
        </div>
      </div>
      <div v-if="showTicketOrder" class="continue-button">
        <button @click="next">Continue</button>
      </div>
    </div>
    <div class="checkout-popup">
      <Popup title="Checkout" :show="showPopup">
        <transition name="fade">
          <div v-if="checkout.step === 1" class="popup-container">
            <h4>Guests Info</h4>
            <div v-for="(guest, index) in guests" :key="index">
              <h3>Guest {{ index + 1 }}</h3>
              <div class="inputs">
                <div class="input full">
                  <label>Select Ticket</label>
                  <v-select
                    id="mySelect"
                    label="name"
                    :reduce="(t) => Object.assign({ id: t.id, name: t.name })"
                    v-model="guest.selected_ticket"
                    :options="ticketOptions"
                  >
                  </v-select>
                </div>
                <div class="input">
                  <label>First Name</label>
                  <input v-model="guest.first_name" type="text" />
                </div>
                <div class="input">
                  <label>Last Name</label>
                  <input v-model="guest.last_name" type="text" />
                </div>
                <div class="input">
                  <label>Email</label>
                  <input v-model="guest.email" type="text" />
                </div>
                <div class="input">
                  <label>Phone</label>
                  <input
                    @change="acceptNumber(guest)"
                    v-model="guest.phone"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="btns">
              <button @click="closePopup" class="btn text_btn">Cancel</button>
              <button class="btn" @click="checkoutNextStep">Continue</button>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div v-if="checkout.step === 2" class="popup-container">
            <h4>Billing Info</h4>
            <div class="inputs">
              <div class="input">
                <label>First Name</label>
                <input v-model="user.first_name" type="text" />
              </div>
              <div class="input">
                <label>Last Name</label>
                <input v-model="user.last_name" type="text" />
              </div>
              <div class="input">
                <label>Email</label>
                <input v-model="user.email" type="text" />
              </div>
              <div class="input">
                <label>Phone</label>
                <input
                  @change="acceptNumber(user)"
                  v-model="user.phone"
                  type="text"
                />
              </div>
              <g-address
                :inputAddress="user.address"
                @autoCompleteAddress="autoCompleteAddress"
              />
            </div>
            <div class="btns">
              <button @click="closePopup" class="btn text_btn">Cancel</button>
              <button class="btn" @click="checkoutNextStep">Continue</button>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div v-if="checkout.step === 3" class="popup-container">
            <div
              v-if="
                order_type === 'Paid Directly By Credit Card' ||
                order_type === 'Paid Directly By Debit Card'
              "
            >
              <h4>Payment Info</h4>
              <div class="inputs">
                <div class="input full">
                  <label>Name on Card</label>
                  <input v-model="order.payment_info.name" type="text" />
                </div>
                <div class="input full">
                  <label>Card Number</label>
                  <input v-model="order.payment_info.number" type="text" />
                </div>
                <div class="input">
                  <label>Expiration</label>
                  <input v-model="order.payment_info.expiration" type="text" />
                </div>
                <div class="input">
                  <label>CVV</label>
                  <input v-model="order.payment_info.cvv" type="text" />
                </div>
              </div>
              <div class="btns">
                <button @click="closePopup" class="btn text_btn">Cancel</button>
                <button class="btn" @click="save">Checkout</button>
              </div>
            </div>
            <div v-else>
              <p>{{ order_type }}</p>
              <button class="btn" @click="save">Checkout</button>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div v-if="checkout.step === 4" class="popup-container">
            <h4>Confirmation</h4>
            <div class="popup-content">
              <div class="input">
                <label>Order Number:</label>
                <span>{{ order.order_number }}</span>
              </div>
              <div class="input">
                <label>Order Total:</label>
                <span>${{ total }}</span>
              </div>
            </div>
            <div class="btns">
              <button class="btn" @click="closePopup(true)">Close</button>
            </div>
          </div>
        </transition>
      </Popup>
    </div>
  </div>
</template>

<script>
import firebase, { auth } from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import GoogleAddress from "@/components/Tools/GoogleAddress.vue";
import Swal from "sweetalert2";

import swal from "sweetalert";
import Title from "@/components/Title.vue";
import Popup from "../components/Popup";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const functions = fb.default.functions;
var moment = require("moment");

export default {
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    heading: Title,
    Popup,
    "g-address": GoogleAddress,
  },
  data() {
    return {
      selectedTickets: {},
      showPopup: false,
      checkout: {
        step: 1,
      },
      event: null,
      face_values: {},
      total: 0,
      quantity: 0,
      tickets: [],
      user: {
        first_name: null,
        last_name: null,
        company: null,
        phone: null,
        email: null,
        address: {
          name: null,
          address_1: null,
          address_2: null,
          address_3: null,
          city: null,
          state: null,
          country: null,
        },
        access: {
          admin: false,
          exhibitor: false,
          attendee: true,
        },
      },
      payment: {
        number: null,
        ccv: null,
        expiration: null,
      },
      order: {
        created_at: Date.now(),
        ticket_paths: [],
        event_id: null,
        ticket_num: null,
        total_cost: null,
        payment_info: {
          name: null,
          last_4: null,
          exp: null,
          card_type: null,
        },
      },
      order_id: null,
      order_type: null,
      order_types: [
        "Paid with Check",
        "Paid with Cash",
        "Paid directly online with PayPal",
        "Paid online non-PayPal",
        "Complimentary",
        "No payment necessary",
        "Paid With Voucher",
        "Paid Directly By Credit Card",
        "Paid Directly By Debit Card",
        "Other",
      ],
      ticketOptions: [],
      guests: [],
      buyer_path: null,
      error: null,
      user_ref: null,
      sendEmail: functions.httpsCallable("sendEmail"),
    };
  },
  firestore() {
    return {
      event: db.collection("event").doc(this.$route.params.id),
      tickets: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("ticket"),
    };
  },
  computed: {
    resetUser() {
      return {
        first_name: null,
        last_name: null,
        company: null,
        phone: null,
        email: null,
        address: {
          name: null,
          address_1: null,
          address_2: null,
          address_3: null,
          city: null,
          state: null,
          country: null,
        },
        access: {
          admin: false,
          exhibitor: false,
          attendee: true,
        },
      };
    },
    resetOrder() {
      return {
        created_at: Date.now(),
        ticket_paths: [],
        event_id: null,
        ticket_num: null,
        total_cost: null,
        payment_info: {
          name: null,
          last_4: null,
          exp: null,
          card_type: null,
        },
      };
    },
    showTicketOrder() {
      return this.tickets.length;
    },
    event_ref() {
      return db.collection("event").doc(this.$route.params.id);
    },
  },
  methods: {
    autoCompleteAddress(payload) {
      this.user.address = payload;
    },
    async save() {
      await Promise.all([
        this.saveBuyer(),
        this.saveGuests(),
        this.saveOrder(),
        this.sendEmailInvite(),
        this.updateTicket(),
        this.checkoutNextStep(),
      ]);
    },
    acceptNumber(guest) {
      var x = guest.phone
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      guest.phone = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },
    saveBuyer() {
      let user = this.user;
      let ref = db.collection("user").doc();
      this.buyer_path = ref.path;
      return ref.set(user, { merge: true });
    },
    saveOrder() {
      let order = this.order;
      let ticketIds = Object.keys(this.selectedTickets);
      let event_id = this.event.id;
      order.created_at = Date.now();
      order.billing_address = this.user.address;
      order.event_id = event_id;
      order.total_cost = Number(this.total);
      order.ticket_num = this.quantity;
      order.buyer_path = this.buyer_path;
      order.payment_info.name = `${this.user.first_name} ${this.user.last_name}`;
      order.order_number = Math.random().toString(36).substr(0, 10).toString();

      let ref = db.collection("event").doc(event_id).collection("orders").doc();
      this.order_id = ref.id;

      return ref
        .set(order, { merge: true })
        .then(() => this.saveLineItems(ticketIds, ref));
    },
    saveLineItems(ticketIds, order_ref) {
      const batch = db.batch();
      let batch_arr = ticketIds.map((id) => {
        let ticket = this.tickets.find((t) => t.id == id);
        let ticket_ref = this.event_ref.collection("ticket").doc(id);
        let line_item_ref = order_ref.collection("line_items").doc(id);
        batch.set(
          line_item_ref,
          {
            created_at: Date.now(),
            name: ticket.name,
            unit_price: ticket.price,
            total_price: this.selectedTickets[id] * ticket.price,
            type: ticket.type,
            quantity: this.selectedTickets[id],
            event_id: this.event.id,
            ticket_path: ticket_ref.path,
          },
          { merge: true }
        );
      });
      return batch.commit();
    },
    saveGuests() {
      const batch = db.batch();
      let event_id = this.event.id;
      let user = this.user;
      this.guests = this.guests.map((guest) => {
        let formattedGuest = {
          created_at: Date.now(),
          first_name: guest.first_name,
          last_name: guest.last_name,
          register_date: Date.now(),
          approval_date: null,
          status: "REGISTERED",
          order_id: this.order_id,
          uid: null,
          ticket: guest.selected_ticket,
          checkedIn: false,
        };
        guest = formattedGuest;
        let ref = db
          .collection("event")
          .doc(event_id)
          .collection("guest")
          .doc();
        ref.set(guest, { merge: true });
        guest.id = ref.id;
        return guest;
      });
      return true;
    },
    sendEmailInvite() {
      let emails = this.guests.map((guest) => {
        return Object.assign({
          email: guest.email,
          type: "to",
        });
      });
      let merge_vars = this.guests.map((guest) => {
        return Object.assign({
          rcpt: guest.email,
          vars: [
            {
              name: "name",
              content: `${guest.first_name} ${guest.last_name}`,
            },
            {
              name: "link",
              content: `https://journey-landing.firebaseapp.com/${this.event.id}/${this.order_id}/${guest.id}/signup`,
            },
          ],
        });
      });
      return this.sendEmail({
        template_name: "journey-guest-order-confirmation",
        from_email: null,
        to_email: emails,
        global_merge_vars: [
          {
            name: "event_img",
            content: this.event.event_image,
          },
          {
            name: "event_name",
            content: this.event.title,
          },
          {
            name: "date",
            content: moment(this.event.start_time).format("MM Do YYYY"),
          },
          {
            name: "time",
            content: moment(this.event.start_time).format("h:mm:ss a"),
          },
          {
            name: "venue",
            content: this.event.title,
          },
          {
            name: "location",
            content: `${this.event.address.address_1} ${this.event.address.city} ${this.event.address.state} ${this.event.address.zip}`,
          },
          {
            name: "map_link",
            content: `https://www.google.com/maps/place/${this.event.address.address_1}+${this.event.address.city}+${this.event.address.state}+${this.event.address.zip}`,
          },
        ],
        merge_vars: merge_vars,
      }).then((res) => res);
    },
    updateTicket() {
      const batch = db.batch();
      const event_id = this.event.id;
      for (let i = 0; i < this.tickets.length; i++) {
        if (this.selectedTickets[this.tickets[i].id]) {
          let new_quantity =
            Number(this.tickets[i].amount_available) -
            Number(this.selectedTickets[this.tickets[i].id]);
          let ref = db
            .collection("event")
            .doc(event_id)
            .collection("ticket")
            .doc(this.tickets[i].id);

          batch.update(ref, { amount_available: new_quantity });
        }
      }

      return batch.commit();
    },
    resetState() {
      this.total = 0;
      this.quantity = 0;
      this.order = this.resetOrder;
      this.checkout.step = 1;
      this.face_values = {};
      this.selectedTickets = {};
      this.order_id = null;
      this.guests = [];
    },
    checkoutNextStep() {
      let step = this.checkout.step;

      if (step == 1) {
        if (!this.validate()) {
          return Swal.fire(
            "Missing Fields! (*)",
            "Please fill in all required fields (*)",
            "warning"
          );
        }
      }
      this.checkout.step = 0;
      setTimeout(() => {
        this.checkout.step = step += 1;
      }, 500);
    },
    openPopup() {
      this.showPopup = true;
    },
    closePopup(complete = false) {
      if (complete) {
        this.showPopup = false;
        this.resetState();
      } else {
        swal({
          title: "Are you sure you want to reset checkout process?",
          icon: "warning",
          buttons: ["Cancel", "Yes"],
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            this.showPopup = false;
            this.resetState();
          }
        });
      }
    },
    addTicket(type) {
      let new_ticket_ref = db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("ticket")
        .doc();

      let ticket = {
        description: type,
        ticket_id: new_ticket_ref.id,
        accept_donation: type == "donate" ? true : false,
        amount_available: 0,
        price: 0,
        name: null,
      };
      this.tickets.push(ticket);
    },
    calculateTotal() {
      let total = 0;
      for (let key in this.face_values) {
        if (this.face_values[key]) {
          total += parseInt(this.face_values[key]);
        } else {
          total += 0;
        }
      }
      this.total = total;
    },
    calculateFaceValue(ticket) {
      if (this.selectedTickets[ticket.ticket_id] > ticket.amount_available) {
        return Swal.fire("", "Maximum quantity exceeded", "warning").then(
          () => {
            this.selectedTickets[ticket.ticket_id] = 0;
            this.face_values[ticket.ticket_id] = 0;
          }
        );
      } else {
        this.face_values[ticket.ticket_id] =
          this.selectedTickets[ticket.ticket_id] * ticket.price;
        this.calculateTotal();
      }
    },
    priceFilter(ticket) {
      if (ticket.type == "donate") {
        return "Donation";
      } else if (ticket.type == "free") {
        return "Free";
      } else {
        return `$${ticket.price}`;
      }
    },
    deleteTicket(ticket) {
      db.collection("event")
        .doc(this.$route.params.id)
        .collection("ticket")
        .doc(ticket.ticket_id)
        .delete();

      this.tickets = this.tickets.filter(
        (t, i) => t.ticket_id !== ticket.ticket_id
      );
    },
    isQuantityAvailable() {
      for (let i = 0; i < this.tickets.length; i++) {
        for (let t in this.selectedTickets) {
          if (this.tickets[i].id === t) {
            if (
              Number(this.selectedTickets[t]) >
              Number(this.tickets[i].amount_available)
            ) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
    },
    next() {
      for (let t in this.selectedTickets) {
        if (this.selectedTickets[t] > 0) {
          this.quantity += Number(this.selectedTickets[t]);
        }
      }
      if (this.isQuantityAvailable()) {
        return;
      }
      if (!this.tickets.length || this.quantity <= 0) {
        Swal.fire(
          "No tickets has been added",
          "Add tickets before continuing",
          "warning"
        );
      } else {
        this.showPopup = true;
      }
    },
    handleError(error) {
      this.error = error.message;
      setTimeout(() => {
        this.error = "";
      }, 3000);
    },
    validate() {
      let valid = true;
      this.guests.forEach((guest) => {
        for (const key in guest) {
          if (key == "first_name" || key == "last_name" || key == "email") {
            if (!guest[key]) valid = false;
          }
        }
      });

      return valid;
    },
  },
  watch: {
    quantity() {
      let count = this.quantity;
      this.guests = [];
      for (let i = 1; i <= count; i++) {
        let guest = {
          first_name: null,
          last_name: null,
          company: null,
          phone: null,
          email: null,
          selected_ticket: null,
        };
        this.guests.push(guest);
      }
    },
    selectedTickets: {
      handler() {
        this.ticketOptions = this.tickets.filter((t) => {
          return this.selectedTickets[t.id];
        });
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.add-attendees-table {
  td {
    padding: 20px 10px 20px 15px;
    border-bottom: 1px solid #eaeaea;
    input {
      box-shadow: 0px 2px 4px #0000002e;
      padding-left: 25px;

      width: 80%;
    }
  }

  .face-value {
    display: flex;
    align-items: center;
    input {
      padding-left: 25px;
      box-shadow: 0px 2px 4px #0000002e;
    }
    &::before {
      position: relative;
      content: "$";
      left: 18px;
    }
  }
}

.input-symbol-dollar {
  position: relative;
  input {
    padding-left: 18px;
    border: 1px solid #fba500;
  }
  &::before {
    position: absolute;
    top: 0;
    content: "$";
    left: 9px;
  }
}

.continue-button {
  display: flex;
  justify-content: flex-end;
  button {
    background-color: #fba500;
    padding: 10px 20px 10px 20px;
    color: white;
    font-size: 13px;
    border: none;
    border-radius: 3px;
  }
}

.checkout-popup {
  .btns {
    bottom: 20px;
  }
  .popup-container {
    // height: 400px;
    .popup-content {
      .input {
        margin-bottom: 15px;
        label {
          margin-right: 20px;
        }
      }
    }
  }
  .inputs {
    height: unset !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .input {
      width: 48%;
      &.full {
        width: 100%;
      }
    }
  }
}
</style>
